import { useState } from 'react';

import { FormValues } from '../../types';

type Params = {
  activeIndex: number;
  activeRef:
    | FormValues['artifacts'][number]['files'][number]['ref']
    | undefined;
  refs: Array<string> | undefined;
};

/** Which git ref is selected for a source, resynced whenever the active artifact changes. */
export function useSourceGitRef({ activeIndex, activeRef, refs }: Params) {
  const [gitRef, setGitRef] = useState(activeRef ?? '');
  // The artifact `gitRef` was last derived for; resynced during render on change.
  const [refOwnerIndex, setRefOwnerIndex] = useState(activeIndex);
  if (activeIndex !== refOwnerIndex) {
    setRefOwnerIndex(activeIndex);
    setGitRef(activeRef ?? pickDefaultGitRef(refs));
  }

  return { gitRef, setGitRef };
}

// Mirrors RefSelector's own default-ref priority (main, then master, then first).
function pickDefaultGitRef(refs: Array<string> | undefined): string {
  if (refs?.includes('refs/heads/main')) {
    return 'refs/heads/main';
  }
  if (refs?.includes('refs/heads/master')) {
    return 'refs/heads/master';
  }
  return refs?.[0] ?? 'refs/heads/main';
}
